module.exports = {
  "zones": {
    "Asia/Kuching": ["z", {
      "wallclock": -766972800000,
      "format": "+08",
      "abbrev": "+08",
      "offset": 28800000,
      "posix": -767005200000,
      "save": 0
    }, {
      "wallclock": -879638400000,
      "format": "+09",
      "abbrev": "+09",
      "offset": 32400000,
      "posix": -879667200000,
      "save": 0
    }, {
      "wallclock": -1167609600000,
      "format": "+08/+0820",
      "abbrev": "+08",
      "offset": 28800000,
      "posix": -1167636600000,
      "save": 0,
      "rules": "NBorneo"
    }, {
      "wallclock": -1383436800000,
      "format": "+0730",
      "abbrev": "+0730",
      "offset": 27000000,
      "posix": -1383463280000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 26480000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "NBorneo": [{
      "from": 1935,
      "to": 1941,
      "month": 8,
      "day": [7, 14],
      "time": 0,
      "clock": "wallclock",
      "save": 20,
      "letter": "",
      "saved": 0
    }, {
      "from": 1935,
      "to": 1941,
      "month": 11,
      "day": [7, 14],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 1200000
    }]
  }
};